export const normalizeConfig = (cfg = {}) => {
  const out = { ...cfg };
  const mapInverterType = (value) => {
    if (value === null || value === undefined) return value;
    const raw = String(value).trim();
    const upper = raw.toUpperCase();
    if (upper === 'C' || upper === 'M' || upper === 'P') return upper;
    if (upper === 'CENTRAL') return 'C';
    if (upper === 'MICRO') return 'M';
    if (upper === 'POWEROPTIMIZER' || upper === 'POWER OPTIMIZER') return 'P';
    return value;
  };

  if (out.companyAdditionalInverterIDs == null) {
    out.companyAdditionalInverterIDs = [];
  } else if (Array.isArray(out.companyAdditionalInverterIDs)) {
    out.companyAdditionalInverterIDs = out.companyAdditionalInverterIDs.filter(x => x != null).map(item => {
      // Handle null or undefined quantities in enhanced format objects
      if (item && typeof item === 'object' && (item.quantity === null || item.quantity === undefined)) {
        return { ...item, quantity: 1 };
      }
      return item;
    });
  }

  // Handle null or undefined quantity for primary inverter - set default value of 1
  if (out.inverter) {
    if (out.inverter.type !== undefined) {
      out.inverter = { ...out.inverter, type: mapInverterType(out.inverter.type) };
    }
    if (out.inverter.quantity === null || out.inverter.quantity === undefined) {
      // Set default value of 1 when quantity is null or undefined
      out.inverter = { ...out.inverter, quantity: 1 };
    }
  }

  // Handle null or undefined quantities for additional inverters
  if (Array.isArray(out.additionalInverters)) {
    out.additionalInverters = out.additionalInverters.map(inv => {
      const nextInv = inv && inv.type !== undefined
        ? { ...inv, type: mapInverterType(inv.type) }
        : inv;
      if (inv && (inv.quantity === null || inv.quantity === undefined)) {
        return { ...nextInv, quantity: 1 };
      }
      return nextInv;
    });
  }

  return out;
};
